export default __webpack_public_path__ + "static/media/WNP시스템.fda81567.png";